import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import * as gear from 'services/userGear/selectors'
import * as gearActions from 'services/userGear/actions'
import SidebarWidget from 'components/sidebar/SidebarWidget'
import GearItem from './GearItem'
import styles from './_gearTracker.css'

const mapStateToProps = (state) => ({
  userGear: gear.selectUserGear(state),
})

const mapDispatchToActions = {
  ...gearActions,
}

export class GearTracker extends Component {
  static propTypes = {
    userId: PropTypes.number,
    fetchUserGear: PropTypes.func,
    userGear: PropTypes.array,
  }

  state = {
    loading: true,
  }

  componentWillMount () {
    this.props.fetchUserGear().then(() => {
      this.setState({
        loading: false,
      })
    })
  }

  render () {
    const { userGear } = this.props
    const { loading } = this.state
    const noGear = (userGear.length === 0) && !loading
    return (
      <SidebarWidget>
        <div className={styles.header}>
          <h3>
            <FormattedMessage id='home.geartracker.title' defaultMessage='Gear Tracker' />
          </h3>
          <a className={styles.link} href='/gear/gear-locker/'>
            {noGear ?
              <FormattedMessage id='home.geartracker.add' defaultMessage='Add Gear Now' />
            :
              <FormattedMessage id='home.geartracker.view' defaultMessage='View All' />
            }
          </a>
        </div>

        {noGear ?
          <FormattedMessage id='home.geartracker.nogear' defaultMessage='You haven&#39;t added any gear yet.' />
        : null}
        {userGear.map((item, i) => <GearItem key={i} item={item} />)}
      </SidebarWidget>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(GearTracker)
